import {CustomRefMessage} from "../messages";
import {IMyopComponent} from "../host";

// const space = ' ';
// export const getClasses = async (connectedRef: Ref): Promise<string[]> => (await exec(actAs<HTMLDivElement>(connectedRef).classList)).value.split(space);
// export const addClass = async (connectedRef: Ref, className: string) => {
//     const classes = await getClasses(connectedRef);
//     classes.includes(className) || classes.push(className);
//     // @ts-ignore
//     connectedRef.classList = classes.join(space);
// }
// export const removeClass = async (connectedRef: Ref, className: string,) => {
//     let classes = await getClasses(connectedRef);
//     // @ts-ignore
//     connectedRef.classList = classes.filter(c => c !== className).join(space);
// }
//
//

export const addClass = (component: IMyopComponent, className: string, myopId: string) => {
    component.send(new CustomRefMessage(({ref, _className}) => {
        ref?.classList.add(_className);
    }, {
        elementId: myopId,
        _className: className
    }));
}

export const removeClass = (component: IMyopComponent, className: string, myopId: string) => {
    component.send(new CustomRefMessage(({ref, _className}) => {
        ref?.classList.remove(_className);
    }, {
        elementId: myopId,
        _className: className
    }));
}